export default class PomivalniStrojObj {
    ratings = [0.86, 1.04, 1.04, 1.05, 1.17, 1.3, 1.45, 1.6, 1.72, 1.81];

    strings_ratings = [
        "A+++",
        "A++",
        "A+",
        "A (po 2007)",
        "B (2001-2007)",
        "C (1999-2001)",
        "D (1992-1999)",
        "E (pred 1992)",
        "F (pred 1992)",
        "G (pred 1992)"
    ];

    static curr_use;
    static new_use
    static savings;
    static curr_price;
    static new_price;

    ukrep1;
    ukrep1_savings;
    new_rating;

    ukrep2;
    ukrep2_savings;

    ukrep3;
    ukrep3_savings;

    ukrep4;
    ukrep4_savings;

    ukrep5;
    ukrep5_savings;

    constructor(rating, teden, vikend) {
        this.rating = rating;
        this.teden = teden;
        this.vikend = vikend;
        this.st_select = 4;
        this.short = "PX";
        this.st_ukrepov = 0;
        this.name = "Pomivalni stroj";

        this.my_rating = this.ratings[this.rating - 1];

        for(var i = 0; i < teden.length; i++) {
            this.curr_use += (teden[i] * this.my_rating);
        }

        for(i = 0; i < vikend.length; i++) {
            this.curr_use += (vikend[i] * this.my_rating[i]); // ceneje za vikende??
        }

        this.detail_string = this.strings_ratings[this.rating - 1];
    }
}